import { useEffect, useRef } from "react";
import { Outlet } from "react-router-dom";
import { useSidebar } from "@/components/ui/sidebar";

/** A preferência pertence à visita inteira à central e suas etapas. */
export function ConfigurationServerLayout() {
  const sidebar = useSidebar();
  const initial = useRef({ open: sidebar.open, setOpen: sidebar.setOpen });
  useEffect(() => {
    const previous = initial.current;
    previous.setOpen(false);
    return () => previous.setOpen(previous.open);
  }, []);
  return <Outlet />;
}
